import React from "react";
import styled, { keyframes } from "styled-components";

const RhombusGroupOpacity = keyframes`
0% {
    opacity: 1;
  }
  33.33% {
    opacity: 0;
  }
  66.66% {
    opacity: 1;
  }
  100% {
    opacity: 1;
  }
`;

const Warrper = styled.div<{ widthGroup: string; heightGroup: string; widthFloor: string; heightFloor: string }>`
  --width-RhombusGroup: ${({ widthGroup }) => widthGroup && widthGroup};
  --height-RhombusGroup: ${({ heightGroup }) => heightGroup && heightGroup};
  --width-RhombusFloor: ${({ widthFloor }) => widthFloor && widthFloor};
  --height-RhombusFloor: ${({ heightFloor }) => heightFloor && heightFloor};

  .RhombusGroup {
    width: var(--width-RhombusGroup);
    height: var(--height-RhombusGroup);
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .RhombusFloor {
    width: var(--width-RhombusFloor);
    height: var(--height-RhombusFloor);
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }
  .Rhombus {
    width: 69.5%;
    height: 69.5%;
    background-color: #f7da57;
    transform: rotateZ(45deg);
  }
  .Rhombus1,
  .Rhombus2,
  .Rhombus3,
  .Rhombus4 {
    width: 69.5%;
    height: 69.5%;
    background-color: #f7da57;
    transform: rotateZ(45deg);
    position: absolute;
  }
  .Rhombus1 {
    left: -33%;
    background-color: rgba(247, 218, 87, 0.299999);
  }
  .Rhombus2 {
    left: -8.5%;
    background-color: rgba(247, 218, 87, 0.499999);
  }
  .Rhombus3 {
    right: -8.5%;
    background-color: rgba(247, 218, 87, 0.499999);
  }
  .Rhombus4 {
    right: -33%;
    background-color: rgba(247, 218, 87, 0.299999);
  }
  .RhombusGroupOpacity {
    animation-name: ${RhombusGroupOpacity};
    animation-duration: 3s;
    animation-iteration-count: infinite;
  }
`;
interface RhombusProps {
  widthGroup: string;
  heightGroup: string;
  widthFloor: string;
  heightFloor: string;
}

const Rhombus: React.FC<RhombusProps> = ({ widthGroup, heightGroup, widthFloor, heightFloor }) => {
  return (
    <Warrper widthGroup={widthGroup} heightGroup={heightGroup} widthFloor={widthFloor} heightFloor={heightFloor}>
      <div className="RhombusGroup RhombusGroupOpacity">
        <div className="RhombusFloor">
          <div className="Rhombus"></div>
          <div className="Rhombus1"></div>
          <div className="Rhombus2"></div>
          <div className="Rhombus3"></div>
          <div className="Rhombus4"></div>
        </div>
      </div>
    </Warrper>
  );
};

export default React.memo(Rhombus);
